// src/pages/TermsOfService.js
import React, { useEffect } from 'react';
import './LegalPage.css';

const TermsOfService = () => {

  useEffect(() => {
  window.scrollTo(0, 0);
  }, []);
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms of Service</h1>
        {/* <p>Last updated: [Date]</p> */}
        
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the AmenityScores website ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you disagree with any part of the terms, you may not access the Service.
          </p>
        </section>
        
        <section>
          <h2>2. Use License</h2>
          <p>
            Permission is granted to temporarily access the materials on AmenityScores' website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
          </p>
        </section>
        
        <section>
          <h2>3. User Accounts</h2>
          <p>
            When you create an account with us, you must provide accurate information. You are responsible for safeguarding your password and for any activities under your account.
          </p>
        </section>
        
        <section>
          <h2>4. Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are and will remain the exclusive property of AmenityScores and its licensors. Our trademarks may not be used in connection with any product or service without prior written permission.
          </p>
        </section>
        
        <section>
          <h2>5. Limitation of Liability</h2>
          <p>
            In no event shall AmenityScores, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages resulting from your access to or use of our Service.
          </p>
        </section>
        
        <section>
          <h2>6. Governing Law</h2>
          <p>
            These Terms shall be governed and construed in accordance with the laws of the United Kingdom, without regard to its conflict of law provisions.
          </p>
        </section>
        
        <section>
          <h2>7. Changes to Terms</h2>
          <p>
            We reserve the right to modify or replace these Terms at any time. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.
          </p>
        </section>
        
        <section>
          <h2>8. Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us at:
            <a href="mailto: harry@amenityscores.com">harry@amenityscores.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;